<template>
  <div class="diff-viewer">
    <ts-note v-if="newString === oldString">{{ noChangeMessage }}</ts-note>
    <div
      class="diff-viewer-side-header-wrapper"
      v-show="outputFormat === 'side-by-side'"
    >
      <span class="diff-viewer-side-header">{{ oldStringHeader }}</span>
      <span class="diff-viewer-side-header">{{ newStringHeader }}</span>
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="diffHtml" />
  </div>
</template>

<script>
import { createPatch } from 'diff';
import * as Diff2Html from 'diff2html';
import 'diff2html/bundles/css/diff2html.min.css';
import '@tradeshift/elements.note';

export default {
  name: 'DiffViewer',
  props: {
    oldString: {
      type: String,
      default: '',
    },
    newString: {
      type: String,
      default: '',
    },
    context: {
      type: Number,
      default: 10,
    },
    outputFormat: {
      type: String,
      default: 'line-by-line',
    },
    noChangeMessage: {
      type: String,
      default: '',
    },
    oldStringHeader: {
      type: String,
      default: 'Old Content',
    },
    newStringHeader: {
      type: String,
      default: 'New Content',
    },
  },
  computed: {
    diffHtml() {
      return this.getDiffHtml(
        this.oldString,
        this.newString,
        this.outputFormat
      );
    },
    unifiedDiff() {
      return createPatch('', this.oldString, this.newString, 'Old', 'New', {
        context: this.context,
      });
    },
  },
  methods: {
    getDiffHtml(oldString, newString, outputFormat) {
      const Diff2HtmlConfig = {
        outputFormat,
        renderNothingWhenEmpty: true,
        drawFileList: false,
        diffStyle: 'word',
      };
      const outStr = Diff2Html.parse(this.unifiedDiff, Diff2HtmlConfig);
      return Diff2Html.html(outStr, Diff2HtmlConfig);
    },
  },
};
</script>

<style>
.diff-viewer {
  margin: 0;
}

.d2h-file-wrapper {
  margin-bottom: 0;
}

.diff-viewer-side-header-wrapper {
  font-size: 0;
  background-color: var(--ts-color-gray-lightest);
  border: 1px var(--ts-color-gray-light);
  border-style: none solid;
}

.diff-viewer-side-header {
  display: inline-block;
  width: 50%;
  padding-left: var(--ts-unit-triple);
  font-size: var(--ts-fontsize);
  font-weight: var(--ts-fontweight-bold);
}

.d2h-wrapper .d2h-info,
.d2h-wrapper .d2h-file-header {
  display: none;
}

.d2h-wrapper .d2h-cntx .d2h-code-line,
.d2h-wrapper .d2h-cntx .d2h-code-side-line {
  background-color: var(--ts-color-gray-lightest);
}
</style>
